import ModalTabs from '../../../../../../baseComponents/ModalsLayouts/ModalTabs'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { ComponentTabObject } from '../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import CreateAutoVariants from './Tabs/CreateAutoVariants'
import CreateCustomVariants from './Tabs/CreateCustomVariants'

interface ModalCEProductVariantProps extends ModalEditComponentProps { }

const ModalCEProductVariant: React.FC<ModalCEProductVariantProps> = ({ allRowData, userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    if (!userPermissions) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: CreateAutoVariants, text: t('autoGeneration', 'Generación automática') },
        'custom': { component: CreateCustomVariants, text: t('customGeneration', 'Generación personalizada') }
    }
    return (
        <ModalTabs {...rest} tabs={tabs} tab={'main'} className='notFlexAutoFormRender' userPermissions={userPermissions}></ModalTabs>
    )
}

export default ModalCEProductVariant;